import assetLocationsService from "../../../../services/assetService/assetLocationsService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETLOCATIONS } from "../../../../utils/constants";
import { AssetLocationInterface } from "../../../../models/AssetModel/AssetLocation";

interface AddAssetLocationsContext {
  previousAssLocations: AssetLocationInterface[];
}

const useAddAssetLocations = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    AssetLocationInterface,
    Error,
    AssetLocationInterface,
    AddAssetLocationsContext
  >({
    mutationFn: assetLocationsService.Save,

    onMutate: () => {
      const previousAssLocations =
        queryClient.getQueryData<AssetLocationInterface[]>([
          CACHE_KEY_ASSETLOCATIONS,
          page,
          pageSize,
        ]) || [];

      return { previousAssLocations };
    },

    onSuccess: (savedAssLocation) => {
      queryClient.setQueryData<AssetLocationInterface[]>(
        [CACHE_KEY_ASSETLOCATIONS, page, pageSize],
        (assLocations) =>
          assLocations
            ? [savedAssLocation, ...assLocations]
            : [savedAssLocation]
      );
    },

    onError: (error, newAssLocation, context) => {
      if (!context) return;

      queryClient.setQueryData<AssetLocationInterface[]>(
        [CACHE_KEY_ASSETLOCATIONS, page, pageSize],
        context.previousAssLocations
      );
    },
  });
};

export default useAddAssetLocations;
